// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__UFVdH","title":"styles_title__MGprN","loader":"styles_loader__tlqdf"};